import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ContactInstitutionInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Dependencia a la que pertenece">
      {getFieldDecorator("contactInstitution", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa la dependencia a la que pertenece."
          }
        ],
        initialValue: implementerProfile?.contactInstitution
      })(
        <Input
          disabled={isBusy}
          id="contactInstitution"
          name="contactInstitution"
          placeholder="Dependencia a la que pertenece"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
